import { render, staticRenderFns } from "./Alergias.vue?vue&type=template&id=5cfe2198&"
import script from "./Alergias.vue?vue&type=script&lang=js&"
export * from "./Alergias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports